
ADILF.define('adilf/apps/commentcount/app',['require','exports','module','streamhub-sdk/jquery','adilf/debug','adilf/handler','adilf/context'],function (require, exports, module) {/* Application: Livefyre Comment Counts */
"use strict";

var jquery = require('streamhub-sdk/jquery');
var Debug = require('adilf/debug');
var Handler = require('adilf/handler');
var Context = require('adilf/context');

var CommentCount = function(conf) {
    var self = this;

    if(Handler.apps.CommentCount) {
        Handler.apps.CommentCount.debug.print("CommentCount already instantiated");
        return Handler.apps.CommentCount;
    }

    Handler.apps.CommentCount = self;

    self._viaPilot = (window.location.href.indexOf('al.com/') !== -1);

    conf = conf || {};
    self.conf = conf;
    self.conf.autoStart = (conf.autoStart === false) ? false : true;
    conf.replacer = conf.replacer || function(element, count) {
        count = count || 0;

        // using replacer function means we don't have to hard code a number into the element
        element.innerHTML = (!self._viaPilot && count === 0) ? "+" : count;
    };
    self.debug = new Debug("Comment Counters");
    self.instance = undefined;
    self._scriptLoaded = false;
    self._refreshQueued = false;
    self._locked = false;

    self.init = function() {
        var self = this;
        if(self.instance) return;
        self._loadScript().then(function() {
            self._scriptLoaded = true;
            self.instance = window.LF.CommentCount;
            self.instance(self.conf);
            self.debug.print("Initialized with conf:", self.conf);
            if(self._refreshQueued) {
                self.debug.print("A refresh was queued, executing now");
                self._refreshQueued = false;
                self.refresh();
            }
            window.setInterval(function() {
                self.debug.print("60 sec increment refresh");
                self.refresh();
            }, 60000);
        });
    }.bind(self);

    self._loadViaScript = function() {
        var self = this;
        var promise = jquery.Deferred();

        if (!self._viaPilot) {
            promise.resolve(false);
        } else {
            var gs = document.createElement('script');
            gs.src = '//static' + Context.getTier().envSuffix + '.advance.net/static/social/viafoura/dist/index.bundle.js';
            gs.type = 'text/javascript';
            gs.async = true;
            gs.onload = gs.onreadystatechange = function() {
                var gsrs = this.readyState;
                /* istanbul ignore next */
                if (gsrs && gsrs !== 'complete' && gsrs !== 'loaded') {
                    return;
                }
                self.debug.print("Viafoura embed load complete");
                window.Advance.Viafoura.handler.ready('CommentCount').then(function() {
                    promise.resolve(true);
                });
            };
            var gst = document.getElementsByTagName('script')[0];
            gst.parentNode.insertBefore(gs, gst);
        }
        return promise;
    }.bind(self);

    self._loadScript = function() {
        var self = this;
        var promise = jquery.Deferred();

        self._loadViaScript().then(function() {
            var gs = document.createElement('script');
            gs.src = 'http://' + Context.getTier().lf.jsDomain + '/wjs/v1.0/javascripts/CommentCount.js';
            gs.type = 'text/javascript';
            gs.async = true;
            gs.setAttribute('data-lf-domain', Context.getTier().lf.networkId);
            gs.onload = gs.onreadystatechange = function() {
                var gsrs = this.readyState;
                /* istanbul ignore next */
                if (gsrs && gsrs !== 'complete' && gsrs !== 'loaded') {
                    return;
                }
                jquery(this).trigger('ccLoaded.adi');
                self.debug.print("CommentCount.js load complete");
                promise.resolve(true);
            };
            var gst = document.getElementsByTagName('script')[0];
            gst.parentNode.insertBefore(gs, gst);
        });

        return promise;
    }.bind(self);

    self.destroy = function() {
        this.debug.print("This application cannot self destruct");
    }.bind(self);

    self.refresh = function(callback) {
        if(this.locked()) {
            this.debug.print("Locked, will not issue refresh request");
            return;
        }
        if(!this._scriptLoaded) {
            this.debug.print("Script is not loaded, will not issue refresh request, but we'll queue it");
            this._refreshQueued = true;
            return;
        }
        this.lock();
        this.debug.print("Refreshing");
        callback = callback || self.refreshCallback;
        if(jquery('.livefyre-commentcount').length > 0) {
            var _callback = callback;
            callback = function(response) {
                _callback(response);
                if(this._viaPilot) {
                    window.viafoura.context.loadNewPage(document.getElementById('news-river'), { path: '/' });
                }
                this.unlock(); // monkey pach -- callbacks must call .unlock()!
            }.bind(this);
            this.instance.fetch(callback); 
        } else { 
            this.unlock(); 
        }
    }.bind(self);

    self.locked = function() {
        return this._locked;
    }.bind(self);

    self.lock = function() {
        self.debug.print("Locking");
        this._locked = true;
    }.bind(self);

    self.unlock = function() {
        self.debug.print("Unlocking");
        this._locked = false;
    }.bind(self);

    self.refreshCallback = function(resp) {
        self.debug.print("LF.CommentCount.fetch response:", resp);
        for (var site in resp) {
            if (!resp.hasOwnProperty(site)) {
                continue;
            }
            var thisSite = resp[site];
            for(var article in thisSite) {
                if (!thisSite.hasOwnProperty(article)) {
                    continue;
                }
                var articleInstance = thisSite[article];
                var count = articleInstance.total;
                for(var i=0; i<articleInstance.elements.length; i++) {
                    self.conf.replacer(articleInstance.elements[i], count);
                }
            }
        }
    }.bind(self);

    if(conf.autoStart) { self.init(); }

};

module.exports = CommentCount;
});
